function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.269 3.811a2.54 2.54 0 00-2.343 1.782h-2.64a.758.758 0 000 1.515h2.64a2.54 2.54 0 004.848 0h2.64a.758.758 0 000-1.515h-2.64A2.54 2.54 0 006.27 3.81zm.056 1.511A1.023 1.023 0 017.373 6.35a1.023 1.023 0 11-2.046 0 1.023 1.023 0 01.998-1.028z",
  fill: "currentColor"
});

function SvgCommit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.7 15.875"
  }, props), _ref);
}

export default SvgCommit;